import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const FAQ_ITEMS = [
  { qKey: 'referral.landing.faqQ1', aKey: 'referral.landing.faqA1' },
  { qKey: 'referral.landing.faqQ2', aKey: 'referral.landing.faqA2' },
  { qKey: 'referral.landing.faqQ3', aKey: 'referral.landing.faqA3' },
];

const ReferralFAQ = () => {
  const { t } = useTranslation();
  return (
    <>
      <section aria-label="Frequently Asked Questions">
        <Card className="mt-6">
          <CardHeader>
            <CardTitle as="h2" className="text-lg">{t('referral.landing.faqTitle')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {FAQ_ITEMS.map(({ qKey, aKey }) => (
              <article key={qKey}>
                <h3 className="font-semibold text-sm mb-1">{t(qKey)}</h3>
                <p className="text-sm text-muted-foreground">{t(aKey)}</p>
              </article>
            ))}
          </CardContent>
        </Card>
      </section>

      <p className="text-center text-xs text-muted-foreground mt-4">
        {t('referral.landing.privacyNote')}
      </p>
    </>
  );
};

export default ReferralFAQ;
